
import React from "react";

export const Logo = () => {
  return (
    <span className="text-brutal-black text-xl font-bold font-mono uppercase">
      Spa Sense
    </span>
  );
};
